import { com } from '@eidu/web'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import inviteAuthUser, { InviteAuthUserResult } from './api/entity/user/inviteAuthUser'
import { auditLogKeys } from './queryKeys'
import EntityId = com.eidu.sharedlib.entity.EntityId

const useInviteAuthUser = () => {
  const queryClient = useQueryClient()
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (entityId: EntityId): Promise<InviteAuthUserResult> => inviteAuthUser({ entityId }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: auditLogKeys.all }),
  })
  return { invite: mutateAsync, isPending, error }
}

export default useInviteAuthUser
